<template>
  <aside
    class="grid grid-cols-1 gap-6 pt-3 pe-6 justify-start md:grid-cols-subgrid md:grid-rows-subgrid md:row-span-full md:gap-y-0"
  >
    <h4 v-if="listHeader" class="text-h4 md:col-start-1 col-span-1">
      {{ listHeader }}
    </h4>
    <ul class="contents">
      <slot name="listItems" />
    </ul>
  </aside>
</template>

<script setup lang="ts">
defineProps<{
  listHeader?: string;
}>();
defineSlots<{
  listItems(): unknown;
}>();
</script>
